import { Component, Input } from '@angular/core';
import { ORConnectionChangeOperationsForm } from '@bo-client/shared/models/orderRequestWizard.model';
import { AllAreaEnum } from '@bo-client/activation-management/shared/models/commissioningModel';
import { ConnectionChangeRequestTypeEnum } from '@bo-client/shared/models/connectionChange.dto';
import { ConnectionChangeRequestTypeConfig } from '@bo-client/shared/config.model';
import { Observable } from 'rxjs';
import { FieldConfigEnum } from '@bo-client/shared/constants/enums';
import { Observe } from '@bo-client/shared/observe.util';

@Component({
  selector: 'app-order-request-wizard-operations',
  templateUrl: './order-request-wizard-operations.component.html',
  styleUrl: './order-request-wizard-operations.component.scss'
})
export class OrderRequestWizardOperationsComponent {
  @Input('formGroup') operationsForm: ORConnectionChangeOperationsForm;
  @Input() connectionChangeConfig: ConnectionChangeRequestTypeConfig;
  @Observe('connectionChangeConfig') connectionChangeConfig$: Observable<ConnectionChangeRequestTypeConfig>;

  readonly AllAreaEnum = AllAreaEnum;
  protected readonly FieldConfigEnum = FieldConfigEnum;
}
